var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"detay"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"icerik"},[_c('Yukleniyor',{attrs:{"data":_vm.lo}}),_vm._v(" "),_c('div',{staticClass:"frame"})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sayfahead tek"},[_c('h1',[_vm._v("Web Site Yönetimi")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-223484e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/_web/_route.vue
// module id = 1382
// module chunks = 0